import { render } from "./IntervalDisabledTableRow.vue?vue&type=template&id=12de8e8e&scoped=true"
import script from "./IntervalDisabledTableRow.vue?vue&type=script&lang=js"
export * from "./IntervalDisabledTableRow.vue?vue&type=script&lang=js"

import "./IntervalDisabledTableRow.vue?vue&type=style&index=0&id=12de8e8e&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/plus.centrodeglaucoma.com/darmin-plus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12de8e8e"]])

export default __exports__